import { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks';
import * as cts from '../../constants/ui/svg';
import 'antd/dist/antd.css';
import { IMAGE_BASE_URL_OF_USER } from '../../constants';
import { rankingAction } from 'slices/rankingSlice';
import { shopSettingActions } from 'slices/shopSettingSlice';
import { getToken } from 'helpers';
import noLogo from '../../assets/images/no-logo.png';
import SortByRank from './components/SortByRank';
import Log from './components/Log';
import Memo from './components/Memo';
import Layout from './components/Layout';
import StaffImages from './components/StaffImages';
import ModalDeleteImage from './components/ModalDeleteImage';
import NavMenu from '../../components/Common/NavMenu';
import ShowShopMasterTab from './components/ShowShopMasterTab';
import MasterDefaultAvatar from '../../assets/images/master_default_avatar.png';
import { PermissionStaffCreatorModel } from 'models';
import customHistory from 'utils/customHistory';
import StandByImage from './components/tabs/StandByImages';
import StandByVideos from './components/tabs/StandByVideos';
import ProgramRanking from './components/ProgramRanking';
import ProgramingV2 from './components/ProgramingV2';
type Props = {};
type RankingChildItem = {
  id: number;
  shop_id: number;
  name: string;
  value: number;
  status: number;
  created_at: string;
  updated_at: string;
};

type CombinedItem = {
  order_by: number;
  type: 1 | 2;
  order_by_ranking_id?: number;
  images_slider_id?: number;
  second_change: number;
};
export default function SettingsPage({}: Props) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const token = getToken() as string;
  const navigate = useNavigate();
  const location = useLocation();

  const programmingRef = useRef<{ onSave: () => void; onDelete: () => void }>(null);
  const sortByRankRef = useRef<{ onSave: () => void }>(null);
  const listShopByMasterRoleRef = useRef<{ onSave: () => void }>(null);
  const memoRef = useRef<{ onSave: () => void }>(null);
  const staffImageRef = useRef<{ onSave: () => void; onDelete: () => void }>(null);

  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const shopSettings = useAppSelector((state) => state.shopSetting.shopSetting);
  // const isMaster = useAppSelector((state) => state.auth.isMaster);
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);

  const imageSlider = useAppSelector((state) => state.ranking.imageSlide);
  const orderByImagesSliderRankLoading = useAppSelector(
    (state) => state.ranking.orderByImagesSliderRankLoading
  );
  const addMediaLoading = useAppSelector((state) => state.ranking.addMediaLoading);
  const updatePermissionStaffLoading = useAppSelector(
    (state) => state.shopSetting.updatePermissionStaffLoading
  );

  const listPermissionByUser = useAppSelector((state) => state.shopSetting.permissionByUser);
  const [openMenu, setOpenMenu] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState<any>({});

  // using this state for display overlay onto save button
  // const [isShowDraggingMediaOverlay, setIsShowDraggingMediaOverlay] = useState<{
  //   type: 'image' | 'video' | null;
  //   status: boolean;
  // }>({
  //   status: false,
  //   type: null,
  // });
  const [selectMenu, setSelectMenu] = useState(2);
  const [openModalDeleteImage, setOpenModalDeleteImage] = useState(false);
  const [listImageWaitingScreen, setListImageWaitingScreen] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<any>({});
  const [waitingScreenSlideIntervalSecond, setWaitingScreenSlideIntervalSecond] = useState(0);
  const [selectedLayoutRanking, setSelectedLayoutRanking] = useState(0);
  const [onErrorImg, setOnErrorImg] = useState(false);
  const params = new URLSearchParams(location.search);
  const listShopHasPermission = listPermissionByUser
    .filter((item) => item.name == 'enable_ranking_program_master')
    .map((mapItem) => mapItem.shop_id);

  const handleCheckIsMasterProgram = (selectedProgram: any) => {
    const permissionStaffArr = selectedProgram.permissions_staff_creator;
    if (permissionStaffArr && permissionStaffArr?.length !== 0) {
      const findItemHasMasterPermission = permissionStaffArr?.findIndex(
        (item: PermissionStaffCreatorModel) => item.name == 'enable_ranking_program_master'
      );
      if (findItemHasMasterPermission !== -1 && !selectedProgram.shop_id) {
        return true;
      }
    }
    return false;
  };
  const isMaster = masterInfo.active && !selectShop.id;
  const tab = Number(params.get('tab'));
  const handleChangeTab = (id: number) => {
    navigate(`?tab=${id}`, { replace: true });
  };

  const arrTab = [
    // { id: 1, title: t('SORT_BY_RANK') },
    { id: 3, title: t('STAFF_IMAGES') },
    { id: 2, title: t('STILL_PHOTO') },
    { id: 2.1, title: t('STANDBY_VIDEOS') },
    // { id: 4, title: t('LAYOUT') },
    { id: 5, title: t('MEMO') },
    { id: 6, title: t('LOG') },
    { id: 7, title: t('PROGRAMMING') },
  ];
  // if master role add first tab and delete staff image tab
  if (isMaster) {
    arrTab.unshift({ id: 0, title: t('SHOP_LIST') });
    // remove up staff image
    arrTab.splice(1, 1);
    // remove memo tab
    arrTab.splice(3, 1);
  }
  const fetchWaitingScreenImages = async () => {
    try {
      if (selectShop?.id) {
        const params = {
          shop_id: selectShop?.id,
          type: 1,
        };
        await dispatch(rankingAction.getImageSlider({ token, params }));
        // setListImageWaitingScreen(
        //   imageSlider.sort((a: any, b: any) => a?.order_by - b?.order_by) || []
        // );
      }
    } catch (error) {
      // Handle error
    }
  };

  const onDelete = async () => {
    programmingRef.current?.onDelete();
  };
  const onSubmit = async () => {
    if (token && tab === 0) {
      listShopByMasterRoleRef.current?.onSave();
    } else if (token && tab === 1) {
      sortByRankRef.current?.onSave();
    } else if (tab === 2 || tab === 2.1) {
      // only get media which just uploaded
      let listImageWaitingScreenNew = [...listImageWaitingScreen].filter((item: any) => item.isNew);

      // Create an array of promises for all image uploads
      // listImageWaitingScreenNew.map((image: any) => {
      //   const data = {
      //     imageFile: image.imageFile,
      //     order_by: image?.order_by,
      //     ...(selectShop?.id ? { shop_id: selectShop.id } : { shop_ids: listShopHasPermission }),
      //   };
      //   return dispatch(
      //     rankingAction.addImageSlider({
      //       token,
      //       data,
      //     })
      //   );
      // });

      dispatch(
        rankingAction.addStandByMedia({
          token,
          listMedia: listImageWaitingScreenNew.map((item) => {
            return {
              imageFile: item.imageFile,
              order_by: item?.order_by,
              ...(selectShop?.id
                ? { shop_id: selectShop.id }
                : { shop_ids: listShopHasPermission }),
            };
          }),
        })
      );
      // after save reset media isNew to false to avoid send duplicate media
      setListImageWaitingScreen((prev: any[]) =>
        prev.map((item) => (item.isNew ? { ...item, isNew: false } : item))
      );
      // Wait for all image uploads to complete
      // await Promise.all(uploadPromises);
      if (
        waitingScreenSlideIntervalSecond !== shopSettings?.data?.second_change_image_slider_wait
      ) {
        dispatch(
          shopSettingActions.updateShopSettings({
            token,
            data: {
              shop_id: selectShop.id,
              status: 1,
              nomination_fee: shopSettings?.data?.nomination_fee || 0,
              sub_nomination_fee: shopSettings?.data?.sub_nomination_fee || 0,
              support_nomination_fee: shopSettings?.data?.support_nomination_fee || 0,
              companion_fee: shopSettings?.data?.companion_fee || 0,
              second_change_image_slider_wait: waitingScreenSlideIntervalSecond,
            },
          })
        );
      }

      // await setTimeout(async () => {
      //   await fetchWaitingScreenImages();
      // }, 5000);
    } else if (tab === 3) {
      staffImageRef.current?.onSave();
    } else if (tab === 4) {
      dispatch(
        shopSettingActions.updateShopSettings({
          token,
          data: {
            shop_id: selectShop.id,
            status: 1,
            nomination_fee: shopSettings?.data?.nomination_fee || 0,
            sub_nomination_fee: shopSettings?.data?.sub_nomination_fee || 0,
            support_nomination_fee: shopSettings?.data?.support_nomination_fee || 0,
            companion_fee: shopSettings?.data?.companion_fee || 0,
            layout_ranking: selectedLayoutRanking,
          },
        })
      );
    } else if (tab === 5) {
      memoRef.current?.onSave();
    } else if (tab === 7) {
      programmingRef.current?.onSave();
    }
  };
  const _renderBody = useMemo(() => {
    switch (tab) {
      case 0:
        return masterInfo.active ? <ShowShopMasterTab ref={listShopByMasterRoleRef} /> : <></>;
      case 1:
        return <SortByRank ref={sortByRankRef} />;
      case 2:
        return (
          // <StillPhoto
          //   waitingScreenSlideIntervalSecond={waitingScreenSlideIntervalSecond}
          //   setWaitingScreenSlideIntervalSecond={setWaitingScreenSlideIntervalSecond}
          //   listImageWaitingScreen={listImageWaitingScreen}
          //   setListImageWaitingScreen={setListImageWaitingScreen}
          //   setSelectedImage={setSelectedImage}
          //   setShowModalDelete={setOpenModalDeleteImage}
          //   fetchWaitingScreenImages={fetchWaitingScreenImages}
          // />
          <StandByImage
            listImageWaitingScreen={listImageWaitingScreen.filter(
              (item: any) =>
                item?.link?.includes('jpg') ||
                item?.link?.includes('png') ||
                item?.link?.includes('jpeg') ||
                item?.link?.includes('webp') ||
                item?.fileType === 'image'
            )}
            setListImageWaitingScreen={setListImageWaitingScreen}
          />
        );
      case 2.1:
        return (
          <StandByVideos
            listImageWaitingScreen={listImageWaitingScreen.filter(
              (item: any) => item?.link?.includes('mp4') || item?.fileType === 'video'
            )}
            setListImageWaitingScreen={setListImageWaitingScreen}
          />
        );
      case 3:
        return (
          <StaffImages ref={staffImageRef} setOpenModalDeleteImage={setOpenModalDeleteImage} />
        );
      case 4:
        return (
          <Layout
            selectedLayoutRanking={selectedLayoutRanking}
            setSelectedLayoutRanking={setSelectedLayoutRanking}
          />
        );
      case 5:
        return <Memo ref={memoRef} />;
      case 6:
        return <Log />;
      case 7:
        return <ProgramingV2 ref={programmingRef} setSelectedProgram={setSelectedProgram} />;
      default:
        return <></>;
    }
  }, [tab, waitingScreenSlideIntervalSecond, listImageWaitingScreen, selectedLayoutRanking]);

  const handleDeleteImage = () => {
    switch (tab) {
      case 2:
      case 2.1:
        if (selectShop.id) {
          dispatch(
            rankingAction.deleteImageSlider({
              token,
              id: selectedImage?.id,
              data: { shop_id: selectShop?.id },
            })
          );
        } else {
          dispatch(
            rankingAction.deleteImageSlider({
              token,
              id: selectedImage?.id,
              data: { shop_ids: listShopHasPermission },
            })
          );
        }

        setListImageWaitingScreen((prevList) =>
          prevList.filter((item: any) => item?.id !== selectedImage?.id)
        );
        setOpenModalDeleteImage(false);
        break;
      case 3:
        staffImageRef.current?.onDelete();
        break;
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      const sorted: any = [...imageSlider].sort((a: any, b: any) => a?.order_by - b?.order_by);
      const finalList = isMaster ? sorted : sorted;
      setListImageWaitingScreen(finalList);
    }, 100); // delay nhẹ 100ms

    return () => clearTimeout(timeout);
  }, [imageSlider]);

  // handle if user delete tab "?tab=some_number", we will navigate to default page
  if (params.get('tab') == null) {
    params.set('tab', isMaster ? String(0) : String(3));
    customHistory.replace({ search: params.toString() });
  }

  return (
    <>
      <div className="flex overflow-hidden flex-col w-screen h-screen">
        {/* setting header */}
        <div className="flex items-center justify-between h-[60px] border-b border-border-gray pl-6">
          <div className="flex items-center w-full">
            {/* if master mode, hide menu setting */}
            {!isMaster && (
              <button className="mr-6 border-none" onClick={() => setOpenMenu((prev) => !prev)}>
                <span>{cts.navRanking}</span>
              </button>
            )}
            {/* <img className="h-[30px] w-[115px]" src={logoRank} /> */}
            <span>{cts.logoList}</span>
          </div>
          <button
            onClick={() => {
              navigate('/select-shop');
            }}
            className="flex items-center w-[300px] justify-between border-l border-border-gray border-solid h-[60px] px-6"
          >
            <div className="flex items-center w-fit">
              {isMaster ? (
                <img
                  className="object-cover mr-3 w-10 h-10 rounded-full border border-solid border-border-gray"
                  src={MasterDefaultAvatar}
                />
              ) : (
                <img
                  className="h-10 w-10 rounded-[20px] mr-3 object-cover border-border-gray border-solid border"
                  src={
                    selectShop?.avatar_image && !onErrorImg
                      ? `${IMAGE_BASE_URL_OF_USER}/shop/logo/${selectShop?.avatar_image}`
                      : noLogo
                  }
                  onError={() => setOnErrorImg(true)}
                />
              )}
              <span className="text-base notosans_medium text-[#182230] truncate w-full">
                {isMaster ? t('ADMINISTRATOR_MODE') : selectShop?.name}
              </span>
            </div>
            <div className="ml-2">{cts.changeShop}</div>
          </button>
        </div>
        <div className="p-2 grid grid-cols-[calc(30%-4px)_calc(70%-4px)] gap-2 md:grid-cols-4 h-full w-full bg-[#FAFAFA]">
          <div className="flex flex-col h-full bg-white rounded-lg border border-solid border-border-gray">
            <div className="h-[56px] pl-4 flex items-center justify-start border-b border-border-gray">
              <span className="text-xl notosans_bold text-[#252B37]">{t('SETTING')}</span>
            </div>
            {/* side bar */}
            {arrTab.map((x: any, y) => {
              return (
                <button
                  onClick={() => handleChangeTab(x.id)}
                  key={y}
                  className={`${
                    tab === x.id && 'bg-primary'
                  } h-[50px] flex items-center justify-between px-4 py-2 border-b border-solid border-border-gray`}
                >
                  <span
                    className={`${
                      tab === x.id ? 'text-white notosans_bold' : 'text-[#252B37] notosans_normal'
                    } text-[13px] md:text-base `}
                  >
                    {x.title}
                  </span>
                  <span>{tab === x.id ? cts.leftWhite : cts.left}</span>
                </button>
              );
            })}
          </div>
          <div className="flex z-10 flex-col h-full bg-white rounded-lg border border-solid md:col-span-3 border-border-gray">
            <div className="overflow-y-auto flex-1 h-full">{_renderBody}</div>
            {tab !== 6 && (
              <div
                className={`flex justify-between items-center px-4 w-full border-t border-border-gray h-[68px]`}
              >
                {/* delete button */}
                {/* {tab === 7 && (
                  <>
                    {!orderByImagesSliderRankLoading ? (
                      <>
                        {isMaster ? (
                          <>
                            {handleCheckIsMasterProgram(selectedProgram) ||
                            Object.keys(selectedProgram).length !== 0 ? (
                              <button
                                onClick={onDelete}
                                className="border border-solid border-[#F04438] h-[44px] px-[18px] flex items-center justify-center rounded-[8px] text-[#F04438] text-[16px] notosans_medium"
                              >
                                <span className="mr-1">{cts.deleteIcon}</span>
                                {t('PROGRAMMING')}
                                {t('DELETE')}
                              </button>
                            ) : (
                              <p className="font-notosans-400 text-gray_500"></p>
                            )}
                          </>
                        ) : (
                          <>
                            {!handleCheckIsMasterProgram(selectedProgram) ? (
                              <button
                                onClick={onDelete}
                                className="border border-solid border-[#F04438] h-[44px] px-[18px] flex items-center justify-center rounded-[8px] text-[#F04438] text-[16px] notosans_medium"
                              >
                                <span className="mr-1">{cts.deleteIcon}</span>
                                {t('PROGRAMMING')}
                                {t('DELETE')}
                              </button>
                            ) : (
                              <p className="font-notosans-400 text-gray_500">
                                {t('ADMINISTRATOR_UPLOADED')}
                              </p>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <button
                        onClick={onDelete}
                        className="border border-solid border-[#F04438] h-[44px] px-[18px] flex items-center justify-center rounded-[8px] text-[#F04438] text-[16px] notosans_medium"
                      >
                        <span className="mr-1">{cts.deleteIcon}</span>
                        {t('PROGRAMMING')}
                        {t('DELETE')}
                      </button>
                    )}
                  </>
                )} */}
                <div></div>
                <button
                  disabled={addMediaLoading || updatePermissionStaffLoading}
                  onClick={onSubmit}
                  className={`bg-primary h-11 w-[150px] flex items-center justify-center rounded-lg text-white text-base notosans_medium ${
                    addMediaLoading || updatePermissionStaffLoading
                      ? '!bg-primary/50 cursor-not-allowed'
                      : ''
                  }`}
                >
                  {t('KEEP')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <NavMenu
        setSelectMenu={setSelectMenu}
        selectMenu={selectMenu}
        setOpenMenu={setOpenMenu}
        openMenu={openMenu}
        containerRef={''}
      />
      <ModalDeleteImage
        openConfirm={openModalDeleteImage}
        setOpenConfirm={setOpenModalDeleteImage}
        handleDeleteImage={handleDeleteImage}
        title={t('CONFIRM_DEL_IMG')}
      />
    </>
  );
}
